import _toConsumableArray from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import { focusZone } from '@primer/behaviors';
import { useProvidedRefOrCreate } from './useProvidedRefOrCreate';
export { FocusKeys } from '@primer/behaviors';
export function useFocusZone() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var containerRef = useProvidedRefOrCreate(settings.containerRef);
  var useActiveDescendant = !!settings.activeDescendantFocus;
  var passedActiveDescendantRef = typeof settings.activeDescendantFocus === 'boolean' || !settings.activeDescendantFocus ? undefined : settings.activeDescendantFocus;
  var activeDescendantControlRef = useProvidedRefOrCreate(passedActiveDescendantRef);
  var disabled = settings.disabled;
  var abortController = React.useRef();
  useEffect(function () {
    if (containerRef.current instanceof HTMLElement && (!useActiveDescendant || activeDescendantControlRef.current instanceof HTMLElement)) {
      if (!disabled) {
        var _activeDescendantCont;
        var vanillaSettings = _objectSpread(_objectSpread({}, settings), {}, {
          activeDescendantControl: (_activeDescendantCont = activeDescendantControlRef.current) !== null && _activeDescendantCont !== void 0 ? _activeDescendantCont : undefined
        });
        abortController.current = focusZone(containerRef.current, vanillaSettings);
        return function () {
          var _abortController$curr;
          (_abortController$curr = abortController.current) === null || _abortController$curr === void 0 ? void 0 : _abortController$curr.abort();
        };
      } else {
        var _abortController$curr2;
        (_abortController$curr2 = abortController.current) === null || _abortController$curr2 === void 0 ? void 0 : _abortController$curr2.abort();
      }
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled].concat(_toConsumableArray(dependencies)));
  return {
    containerRef: containerRef,
    activeDescendantControlRef: activeDescendantControlRef
  };
}